import { Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { RutaSelectaHeroCards } from "./RutaSelectaHeroCards";
import { HeroPricingCard } from "./HeroPricingCard";
import { ProductPreview } from "./ProductPreview";

export function HeroSection() {
  return (
    <section className="overflow-hidden border-b border-border bg-background pt-6 pb-8 sm:pt-8 sm:pb-10 lg:pt-10 lg:pb-12">
      <div className="mx-auto min-w-0 max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-6 lg:grid-cols-[1fr_minmax(340px,420px)] lg:items-center lg:gap-8">
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center lg:text-left"
          >
            <p className="mb-4 inline-flex items-center gap-2 rounded-md border border-primary/20 bg-primary/5 px-3 py-1.5 text-sm font-semibold text-primary">
              <Sparkles className="h-4 w-4" /> Recta final ENARM 2026
            </p>
            <h1 className="mx-auto w-full max-w-4xl break-words pb-1 text-2xl font-black leading-[1.25] lg:mx-0 lg:max-w-none sm:text-4xl sm:leading-[1.2] lg:text-[3.25rem] lg:leading-[1.15]">
              Tu complemento de estudio para el <span className="text-primary">ENARM</span>
            </h1>
            <p className="mx-auto mt-3 w-full max-w-3xl text-sm leading-relaxed text-muted-foreground sm:text-base lg:mx-0 lg:max-w-xl lg:text-lg">
              <strong className="font-semibold text-foreground">Flashcards</strong> tipo Anki y <strong className="font-semibold text-foreground">simuladores</strong> organizados por tema, con contenido de <strong className="font-semibold text-foreground">PRONAM, GPC</strong> vigentes e históricas, <strong className="font-semibold text-foreground">NOM, ACLS, PALS, ATLS</strong> y guías y consensos mexicanos.
            </p>
            <p className="mx-auto mt-3 text-sm font-medium text-emerald-600 dark:text-emerald-400">
              ⚡ 3 días de prueba gratis en suscripción mensual. Cancela cuando quieras.
            </p>

            {/* Tarjetas de Ruta Selecta ENARM & Ruta Selecta Exprés */}
            <RutaSelectaHeroCards />
          </motion.div>

          <HeroPricingCard />
        </div>

        <div className="mt-8 lg:mt-10">
          <ProductPreview />
        </div>
      </div>
    </section>
  );
}
